// IMPORT REACT
import React from 'react';

// IMPORT STYLES
import { SC_Section, SC_Overflow } from '../styles';


const YASection = (props) => {    

	return (
		<SC_Overflow overflow={props.angle}>
		    <SC_Section {...props}>
	            {props.children}
	        </SC_Section>
        </SC_Overflow>
	);
    
}
export default YASection;